module.exports = __webpack_public_path__ + "static/media/50d.54489673.svg";